export const CHECKOUT_SOURCE_KEY = "checkout";

export const GIFT_CODE_IDENTIFIER = "GC";
